import styled from "styled-components";
import { TrucksTableStyle } from "@components/trucksTable/trucksTableStyle";

export const TruckTypesTableStyle = styled(TrucksTableStyle)`

`;
